import React, { useState, useReducer } from 'react';
import { Container, Chip, Grow, Grid, InputBase, IconButton } from '@material-ui/core';
// import { Pagination, PaginationItem } from '@material-ui/lab'
import { getProjectsBySearch } from '../../actions/projects';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';

import Projects from '../Projects/Projects';
// import Form from '../Form/Form';
// import Pagination from '../Pagination/Pagination';
import useStyles from './styles';

// import useCommonStyles from '../CommonStyle/commonStyle';
import ProjectPagination from '../ProjectPagination/ProjectPagination';
import GoToTop from '../Functional/GoToTop';

// import { classes } from 'istanbul-lib-coverage';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ProjectList = () => {
    const query = useQuery();
    const [currentId, setCurrentId] = useState(null);
    const [search, setSearch] = useState(query.get('searchQuery') || "");
    const [tags, setTags] = useState<string[]>(query.get('tag')?.split(",") || []);
    const page = Number(query.get('page')) || 1;
    const dispatch = useDispatch();
    const classes = useStyles();
    // const commonClasses = useCommonStyles();
    const history = useHistory();
    const [ignored, forceUpdate] = useReducer(x => x + 1, 0);

    const tagList: string[] = ["#フードロス", "#ごみ問題", "#健康と福祉", "#気候変動", "#ジェンダー", "#テクノロジー", "#生活", "#権利", "#貧困", "#動物愛護", "#ファッション", "#政治", "#農業", "#漁業", "#平和・公正"]

    const searchProject = () => {
        if (search.trim() || tags) {
            console.log("search:");
            console.log(search);
            dispatch(getProjectsBySearch({ search, tags: tags.join(',') }, page));
            history.push(`/projects/?searchQuery=${search || ''}&tags=${tags.join(',')}&page=${page}`);
            console.log("searched");


        } else {
            history.push('/');
        }
    };

    //@ts-ignore
    const handleKeyPress = (e) => {
        if (e.charCode === 13) {
            searchProject();
            console.log("enter pressed");
        }
        console.log(e);
    };

    //@ts-ignore
    const chipClick = (e) => {
        const tagClicked = e.target.innerText.slice(1);
        // console.log(e.target.innerText);

        if (tags.includes(tagClicked)) {
            setTags(tags.filter((tag) => tag !== tagClicked));
        }
        else {
            setTags([...tags, tagClicked]);
        }
        forceUpdate();
    };

    // const handleAdd = (tag: string) => { setTags([...tags, tag]); };

    // const handleDelete = (tagToDelete: string) => { setTags(tags.filter((tag) => tag !== tagToDelete)); };


    return (
        <Grow in>
            <Container maxWidth="lg">
                <Container className={classes.gridContainer}>
                    <Grid container item xs={12} sm={8} md={8} direction="column" alignItems="center" className={classes.searchSession}>

                        {/* <AppBar className={classes.appBarSearch} position="static" color="inherit"> */}
                        <Grid className={classes.searchDiv}>
                            <InputBase
                                name="search"
                                //variant="outlined"
                                placeholder="プロジェクトを探す"
                                fullWidth
                                value={search}
                                className={classes.searchBar}
                                onKeyPress={handleKeyPress}
                                onChange={(e) => { setSearch(e.target.value); }} />
                            <IconButton onClick={searchProject}>
                                <SearchIcon className={classes.searchIcon} />
                            </IconButton>
                            {/* <Button onClick={searchProject} variant="contained" color="primary">検索</Button> */}
                        </Grid>

                        <Grid container className={classes.tagListGrid} direction="row" justifyContent="center">
                            {tagList.map((tag, index) => {
                                if (tags.includes(tag.slice(1))) { return (<Chip key={index} onClick={chipClick} label={tag} className={classes.tagChipClicked} />) }
                                else { return (<Chip key={index} onClick={chipClick} label={tag} className={classes.tagChip} />) }
                            })}
                        </Grid>

                        {/* </AppBar> */}
                        {/* <Form currentId={currentId} setCurrentId={setCurrentId} /> */}

                    </Grid>
                    <Grid container item xs={12} sm={12} md={12} className={classes.projectsGrid} justifyContent="center">
                        <Projects setCurrentId={setCurrentId} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} className={classes.pageNumberSection}>
                        <ProjectPagination page={page} search={search} tags={tags} />
                    </Grid>
                    <GoToTop />
                </Container>
            </Container>
        </Grow>
    )
};

export default ProjectList;